import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IFooterVisibilityObservableResult } from '../interfaces/footer-visibility-observable-result.interface';

@Injectable({
    providedIn: 'root'
})
export class PageContainerService {

    private footerVisible = new BehaviorSubject<IFooterVisibilityObservableResult>({visible: false});
    public footerVisible$ = this.footerVisible.asObservable();

    public setFooterVisibility(visible: boolean, name?: string): void {
        this.footerVisible.next({
            visible,
            name
        });
    }
}
